// extracted by mini-css-extract-plugin
module.exports = {"container":"status-icon_container__1I-0t","unread-counter":"status-icon_unread-counter__6D0vP"};